import {
    Typography,
    IconButton,
    Grid,
    Paper,
    useTheme,
    Button,
    Popper,
    Grow,
    ClickAwayListener,
    MenuList,
    MenuItem,
    Box,
    useMediaQuery
} from '@mui/material'
import {
    KeyboardArrowDown,
    Search,
} from '@mui/icons-material'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Dayjs } from 'dayjs';

import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { useActions } from '../../../hooks/useActions';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';

import { GridAnnouncementsStyle, SearchTextFieldStyle } from '../Announcements/styled';

import { oops } from '../../../assets/icons';

import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import AnnouncementItem from '../../../components/AnnouncementItem';
import ButtonDatePicker from '../../../components/Button/ButtonDatePicker';
import Reporting from '../HomePage/reportingSmall';
import Contacts from '../HomePage/contacts';

import "dayjs/locale/uk";
import SendPulseForms from '../../../components/SendPulseForms';
import ReactPlayer from 'react-player';
import ProjectsSimilar from './ProjectsSimilar';
import ProjectsSimilarTablet from './ProjectsSimilarTablet';
import React from 'react';
import ProjectsSimilarPhone from './ProjectsSimilarPhone';



const ProjectPage = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const { GetAnnouncementByUrlSlug } = useActions();
    const { announcementPage } = useTypedSelector((store) => store.announcementUser);

    let { urlSlug } = useParams();

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Проєкти", urlSlug: "/projects" },
        { name: announcementPage.title, urlSlug: "" },
    ]);


    useEffect(() => {
        document.title = announcementPage.title != "" ? announcementPage.title : "About Ukraine";

        setBreadcrumbs([{ name: "Проєкти", urlSlug: "/projects" }, { name: announcementPage.title, urlSlug: "" }])

        getData();
    }, [urlSlug, announcementPage.title])

    const getData = async () => {
        if (!urlSlug)
            return;
        try {
            await GetAnnouncementByUrlSlug(urlSlug)
        } catch (ex) {
        }
    };


    return (
        <Grid container spacing={0} columns={{ xs: 4, md: 5, lg: 12 }} sx={{ mt: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "43px", lg: "120px" } }}>
            <Grid item xs={4} md={5} lg={12}>
                <BreadcrumbsComponent elements={breadcrumbs} />
            </Grid>
            {announcementPage.contents.length !== 0 && announcementPage.contents.map((item, index) => {
                return (
                    <>
                        {index === 1
                            && <Grid key={`project_title`} item xs={4} md={5} lg={12} sx={{ mt: "20px" }}>
                                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "18px", md: "26px", lg: "30px" }} lineHeight={{ xs: "24px", md: "32px" }} >
                                    {announcementPage.title}
                                </Typography>
                            </Grid>
                        }
                        {item.contentTypeId === 1
                            && <Grid key={`project_content_${index}`} item xs={4} md={5} lg={12} sx={{ mt: "20px" }}>
                                <div className="ql-editor" dangerouslySetInnerHTML={{ __html: item.content }} />
                            </Grid>
                        }
                        {(item.contentTypeId === 2 && item.additionalContent === "")
                            && <Grid key={`project_content_${index}`} item xs={4} md={5} lg={12} sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
                                <img
                                    loading="lazy" src={item.content} alt="project_content_image" style={{ maxWidth: "100%", height: "auto" }} />
                            </Grid>
                        }
                        {(item.contentTypeId === 2 && item.additionalContent !== "")
                            && <React.Fragment key={`project_additional_content_${index}`}>
                                <Grid item lg={6} sx={{ display: { xs: "none", lg: "flex" }, justifyContent: "center", height: "377px", mt: "20px" }}>
                                    <img
                                        loading="lazy" src={item.content} alt="project_content_image" style={{ maxWidth: "97%", height: "auto" }} />
                                </Grid>
                                <Grid item lg={6} sx={{ display: { xs: "none", lg: "flex" }, justifyContent: "center", height: "377px", mt: "20px" }}>
                                    <img
                                        loading="lazy" src={item.additionalContent} alt="project_content_image" style={{ maxWidth: "97%", height: "auto" }} />
                                </Grid>
                                <Grid item xs={4} md={5} sx={{ display: { xs: "flex", lg: "none" }, justifyContent: "space-between", flexWrap: "wrap", height: { xs: "403px", md: "213px" }, mt: "20px" }}>
                                    <Box sx={{ width: { xs: "362px", md: "368px" }, height: { xs: "198px", md: "inherit" } }}>
                                        <img
                                            loading="lazy" src={item.content} alt="project_content_image" style={{ width: "inherit", height: "inherit", borderRadius: "8px" }} />
                                    </Box>
                                    <Box sx={{ width: { xs: "362px", md: "368px" }, height: { xs: "198px", md: "inherit" }, mt: { xs: "7px", md: "0px" } }}>
                                        <img
                                            loading="lazy" src={item.additionalContent} alt="project_content_image" style={{ width: "inherit", height: "inherit" }} />
                                    </Box>
                                </Grid>
                            </React.Fragment>
                        }
                        {item.contentTypeId === 3
                            && <Grid key={`project_content_${index}`} item xs={4} md={5} lg={12} sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
                                <ReactPlayer url={item.content} controls={true} width="100%" height="600px" />
                            </Grid>
                        }
                    </>
                );
            })}
            <Grid item xs={4} md={5} lg={12} sx={{ display: (announcementPage.isFormNeeded ? "flex" : "none"), justifyContent: "center", mt: "20px" }}>
                {(isXl || isLg || isMd) && <Box>
                    <SendPulseForms isXs={false} />
                </Box>}
                {isXs && <Box>
                    <SendPulseForms isXs={true} />
                </Box>}
            </Grid>
            {/* Інші події */}
            {(isXl || isLg) && <ProjectsSimilar urlSlug={urlSlug} />}
            {isMd && <ProjectsSimilarTablet urlSlug={urlSlug} />}
            {isXs && <ProjectsSimilarPhone urlSlug={urlSlug} />}
            {/* Контакти */}
            <Contacts />
        </Grid>
    )
}

export default ProjectPage